<template>
  <div class="card w-full">
    <card-header :title="'Orden #' + order.id">
      <template #badge>
        <status-badge status="ready_for_pickup" />
      </template>
    </card-header>

    <p class="text-xs text-content-400">
      Última actualización: {{ formatDatetime(order.updated_at) }}
    </p>

    <div class="detail-grid mt-2">
      <detail-field label="Cliente">
        <router-link
          :to="{
            name: 'clientsDetail',
            params: { id: order.client.id },
          }"
          class="underline system-button"
          >{{ order.client.name }} {{ order.client.last_name }}</router-link
        >
      </detail-field>

      <detail-field v-if="order.diet && order.diet.pet" label="Mascota">
        <router-link
          :to="{
            name: 'petsDetail',
            params: { id: order.diet.pet.id },
          }"
          class="underline system-button"
          >{{ order.diet.pet.name }}</router-link
        >
      </detail-field>

      <detail-field label="Fecha de entrega programada" :value="formatDate(order.min_delivery_date)" />

      <detail-field
        v-if="order.delivery_date"
        label="Fecha de entrega realizada"
        :value="formatDatetime(order.delivery_date)"
      />

      <detail-field label="Semanas" :value="order.weeks" />

      <detail-field label="Método de entrega" :value="order.pickup_delivery ? 'Pick-Up' : 'Envío'" />
    </div>

    <branch-component class="mt-2" :branch="order.branch" />

    <slot></slot>
  </div>
</template>

<script>
import BranchComponent from "../ui/Branch";
import OptionsMenu from "../ui/OptionsMenu";
import { formatDate, formatDatetime } from "@/utils/dateFormatter";
export default {
  name: "Ready For Pickup",

  components: {
    OptionsMenu,
    BranchComponent,
  },

  props: {
    order: Object,
  },

  methods: {
    formatDate,

    formatDatetime,

    getOptions(order) {
      let options = [{ action: "pickup", label: "Recoger en sucursal" }];

      if (
        !order.pickup_delivery &&
        order.related_shipment_orders &&
        order.related_shipment_orders.length > 0
      ) {
        options.push({
          action: "separate",
          label: "Enviar orden por separado",
        });
      }

      return options;
    },
  },
};
</script>